import { render, staticRenderFns } from "./PrepostHomeSroDash.vue?vue&type=template&id=5080c056&scoped=true"
import script from "./PrepostHomeSroDash.vue?vue&type=script&lang=js"
export * from "./PrepostHomeSroDash.vue?vue&type=script&lang=js"
import style0 from "./PrepostHomeSroDash.vue?vue&type=style&index=0&id=5080c056&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5080c056",
  null
  
)

export default component.exports